// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__F5Trp","sm":"Avatar_sm__aTnja","xl":"Avatar_xl__K9IOx"};